import ReactGA from "react-ga4";

// Logs a custom event to Google Analytics 4
export function logEvent({ action, category, params }) {
  if (!action || !category) {
    throw new Error("Both 'action' and 'category' are required for GA events.");
  }
  ReactGA.event(action, {
    category,
    ...params,
  });
}

// Contact form submitted successfully
export function logContactFormSubmission() {
  logEvent({
    action: "contact_form_submitted",
    category: "Contact",
    params: {
      label: "Contact Form",
    },
  });
}

// Contact form submission failed, logs error message in label
export function logContactFormSubmissionFailure(errorMessage) {
  logEvent({
    action: "contact_form_submission_failed",
    category: "Contact",
    params: {
      label: errorMessage || "Unknown error",
    },
  });
}

// Phone call button clicked
export function logPhoneCallClick() {
  logEvent({
    action: "phone_call_clicked",
    category: "PhoneCall",
    params: {
      label: "Phone Call Button",
    },
  });
}

// User viewed 'Why Choose Us' section
export function logWhyChooseUsView() {
  logEvent({
    action: "why_choose_us_viewed",
    category: "WhyChooseUs",
    params: {
      label: "Why Choose Us Section",
    },
  });
}

// Gallery image manually changed
export function logGalleryImageView() {
  logEvent({
    action: "gallery_image_changed",
    category: "Gallery",
    params: {
      label: "Homepage Gallery",
    },
  });
}

// Gallery category manually changed
export function logGalleryCategoryChange() {
  logEvent({
    action: "gallery_category_changed",
    category: "Gallery",
    params: {
      label: "Homepage Gallery",
    },
  });
}

// Facebook icon clicked
export function logFacebookClick() {
  logEvent({
    action: "facebook_icon_clicked",
    category: "Social",
    params: {
      label: "Facebook Icon",
    },
  });
}